module.exports = __webpack_public_path__ + "media/images/default/homepage/about/bus-bf7609ca8e73eac88cd25ce563678244.svg";